import styled from "styled-components";
import { color, typeStyle, units } from "@m/alchemy-theme";
export const DialogBody = styled.div `
  ${typeStyle("bodyS")};
  color: ${color("typeBody")};
  margin: ${units(1)} 0 ${units(3)} 0;
  overflow-y: auto;
  position: relative;
  text-align: ${({ isCentered }) => (isCentered ? "center" : "left")};

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    max-height: ${({ maxBodyHeightForIE }) => maxBodyHeightForIE};
  }
`;
